<template>
	<div>
		<StandardModal data-context="WAF Captcha Modal" :closeable="false" @modal-close="close">
			<template #title>
				<h3 class="heading-5">Let's confirm you are human</h3>
			</template>
			<template #content>
				<div ref="captchaRef"></div>
			</template>
		</StandardModal>
	</div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import StandardModal from '@components/modals/standard-modal.vue';
import { useScriptTag } from '@vueuse/core';

interface Props {
	resolve?: (wafToken: string) => unknown;
	reject?: (error?: unknown) => unknown;
}

interface Emits {
	(e: 'modal-close'): void;
}

const props = withDefaults(defineProps<Props>(), {
	resolve: undefined,
	reject: undefined
});

const emit = defineEmits<Emits>();

const captchaRef = ref<HTMLElement | null>(null);

useScriptTag(`${import.meta.env.VITE_WAF_CAPTCHA_URL}`, () => {
	renderCaptcha();
});

function close(): void {
	emit('modal-close');
}

function onResolve(wafToken: string): void {
	if (props.resolve) {
		props.resolve(wafToken);
	}
	close();
}

function onReject(error?: unknown): void {
	if (props.reject) {
		props.reject(error);
	}
	close();
}

function renderCaptcha() {
	window.AwsWafCaptcha.renderCaptcha(captchaRef.value, {
		apiKey: import.meta.env.VITE_WAF_CAPTCHA_API_KEY,
		onSuccess: (wafToken: string) => {
			onResolve(wafToken);
		},
		onError: (error?: unknown) => {
			onReject(error);
		},
		skipTitle: true
	});
}
</script>
